<template>
  <div style="display: flex;justify-content: center;align-items: center;height: calc(100vh - 84px)">
    <a-button @click="jumpRouter">跳转到收货明细</a-button>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line
  name: 'Receiving-detail-list', // name要和rms配置菜单路由保存一致(首字母大写)
  methods: {
    jumpRouter() {
      const url = process.env.VUE_APP_API_LSCM_URL + '/#/purchase-execute/receive-deliver-goods/receiving-detail-list'
      window.open(url, '_blank')
    }
  },
  created () {
    this.jumpRouter()
  }
}
</script>
